
export default function Footer() {
  return (
    <footer className="bg-gray-800 text-white">
      <div className="px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {/* 聯絡資訊 */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-blue-400">聯絡資訊</h3>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-map-pin-line mr-3 text-blue-400"></i>
                <span className="text-sm">北屯區北屯路388號2樓</span>
              </div>
              <div className="flex items-center">
                <i className="ri-phone-line mr-3 text-blue-400"></i>
                <span className="text-sm">(04)22436255</span>
              </div>
              <div className="flex items-center">
                <i className="ri-mail-line mr-3 text-blue-400"></i>
                <span className="text-sm">richqazstrong@yahoo.com.tw</span>
              </div>
            </div>
          </div>

          {/* 營業時間 */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-blue-400">營業時間</h3>
            <div className="space-y-2 text-sm">
              <div>週一至週五：09:00 - 21:00</div>
              <div>週六：09:00 - 21:00</div>
              <div>週日：休息</div>
              <div className="text-yellow-400 mt-3">
                <i className="ri-information-line mr-2"></i>
                國定假日另行公告
              </div>
            </div>
          </div>

          {/* 快速連結 */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-blue-400">快速連結</h3>
            <div className="space-y-2">
              <a href="#about" className="block text-sm hover:text-blue-400 transition-colors cursor-pointer">關於我們</a>
              <a href="#courses" className="block text-sm hover:text-blue-400 transition-colors cursor-pointer">課程介紹</a>
              <a href="#teachers" className="block text-sm hover:text-blue-400 transition-colors cursor-pointer">師資團隊</a>
              <a href="#facilities" className="block text-sm hover:text-blue-400 transition-colors cursor-pointer">環境設施</a>
            </div>
          </div>

          {/* 社群媒體 */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-blue-400">追蹤我們</h3>
            <div className="flex space-x-4">
              <a href="https://www.facebook.com/profile.php?id=100089989064527&locale=zh_TW" target="_blank" rel="noopener noreferrer" className="w-10 h-10 bg-blue-600 rounded-full flex items-center justify-center hover:bg-blue-700 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-green-500 rounded-full flex items-center justify-center hover:bg-green-600 transition-colors cursor-pointer">
                <i className="ri-line-fill text-white"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-pink-500 rounded-full flex items-center justify-center hover:bg-pink-600 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-white"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* 相關企業 */}
      <div className="border-t border-gray-700 px-6 py-6">
        <div className="max-w-7xl mx-auto">
          <h4 className="text-lg font-bold text-blue-400 mb-4 text-center">相關企業</h4>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
            <a href="https://www.cmapedu.com" target="_blank" rel="noopener noreferrer" className="bg-blue-600 hover:bg-blue-700 transition-colors rounded-lg p-4 cursor-pointer">
              <div className="text-white font-medium">CMAP運動健康品格寒/暑假營隊</div>
            </a>
            <a href="https://www.cmleducate.com" target="_blank" rel="noopener noreferrer" className="bg-blue-600 hover:bg-blue-700 transition-colors rounded-lg p-4 cursor-pointer">
              <div className="text-white font-medium">CM探索教育科技股份有限公司</div>
            </a>
            <a href="https://www.taiwanchild.com" target="_blank" rel="noopener noreferrer" className="bg-blue-600 hover:bg-blue-700 transition-colors rounded-lg p-4 cursor-pointer">
              <div className="text-white font-medium">中華原住民暨弱勢家庭孩童關懷協會</div>
            </a>
          </div>
        </div>
      </div>

      {/* 版權資訊 */}
      <div className="border-t border-gray-700 px-6 py-4">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center text-sm text-gray-400">
          <div>© 2024 威斯理美語安親班. All rights reserved.</div>
          <div className="mt-2 md:mt-0">
            <a href="https://readdy.ai/?origin=logo" className="hover:text-blue-400 transition-colors cursor-pointer">
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
